import type { FeatureCollection } from "geojson";

type LatLngObj = { lat: number; lng: number };
type LngLatTuple = [number, number];
type Coord = LatLngObj | LngLatTuple;

function isTuple(c: Coord): c is LngLatTuple {
  return Array.isArray(c) && c.length === 2;
}

function toLngLat(c: Coord): { lng: number; lat: number } {
  if (isTuple(c)) return { lng: c[0], lat: c[1] };
  return { lng: c.lng, lat: c.lat };
}

export function boundsFromCoords(coords: Coord[]) {
  let west = Infinity,
    south = Infinity,
    east = -Infinity,
    north = -Infinity;

  for (const c of coords) {
    const { lng, lat } = toLngLat(c);
    if (lng < west) west = lng;
    if (lng > east) east = lng;
    if (lat < south) south = lat;
    if (lat > north) north = lat;
  }

  return { west, south, east, north };
}

export function boundsFromFeatureCollection(fc: FeatureCollection) {
  let west = Infinity,
    south = Infinity,
    east = -Infinity,
    north = -Infinity;

  for (const feature of fc.features) {
    const g = feature.geometry;
    if (!g) continue;

    const rings: [number, number][] =
      g.type === "Polygon"
        ? (g.coordinates.flat(1) as [number, number][])
        : g.type === "MultiPolygon"
          ? (g.coordinates.flat(2) as [number, number][])
          : [];

    for (const [lng, lat] of rings) {
      if (lng < west) west = lng;
      if (lng > east) east = lng;
      if (lat < south) south = lat;
      if (lat > north) north = lat;
    }
  }

  if (
    !Number.isFinite(west) ||
    !Number.isFinite(south) ||
    !Number.isFinite(east) ||
    !Number.isFinite(north)
  ) {
    return null;
  }

  return { west, south, east, north };
}
